import React, { Component, useContext, useEffect, useState } from "react";
import "./uploadImageInput.css";
import {
  Delete,
  Download,
  Edit,
  FileOpenOutlined,
  Info,
  MoreVert,
} from "@mui/icons-material";
import { FaEye, FaTrash } from "react-icons/fa";
import Cookies from "js-cookie";
import { Modal } from "bootstrap";
import EditCinImage from "../ProfilePatient/EditCinImage";
import { ApiUrl, FileLink } from "../../config";

class UploadFileInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successMessage: null,
      errorMessage: null,
      recto: null,
      verso: null,
      citoyenInfo: [],
      showModal: false,
      modalImage: "",

      showEditModal: false,
      editingImageType: null,
    };

    this.token = Cookies.get("access_token"); // Store the token here
  }

  handleFileChange = (e, type) => {
    const file = e.target.files[0];
    this.setState({ [type]: file });
  };

  handleSuccess = (message) => {
    this.setState({ successMessage: message }, () => {
      setTimeout(() => this.setState({ successMessage: "" }), 3000); // Clear message after 3 seconds
    });
  };

  componentDidMount() {
    this.getPatientCin();
  }

  truncateFileName = (name) => {
    if (!name) return "";
    const maxLength = 10;
    const fileExtension = name.substring(name.lastIndexOf("."));
    const baseName = name.substring(0, name.lastIndexOf("."));
    if (baseName.length > maxLength) {
      return baseName.substring(0, maxLength) + "..." + fileExtension;
    }
    return name;
  };

  getPatientCin = async () => {
    if (this.token) {
      try {
        const response = await fetch(`${ApiUrl}citoyen/get-cin-images`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        console.log(data);

        if (data.cinRecto || data.cinVerso) {
          this.setState({ citoyenInfo: data });
          console.log(this.citoyenInfo);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  handleDelete = (fileType) => {
    console.log(fileType);
    this.setState({
      [fileType]: null,
    });
  };

  handleSave = async (type) => {
    const token = Cookies.get("access_token");

    if (!token) {
      this.setState({
        errorMessage: "Token d'accès manquant. Veuillez vous reconnecter.",
      });
      return;
    }
    if (token) {
      try {
        // Prepare the form data for file upload
        const formData = new FormData();

        if (type === "recto" && this.state.recto) {
          formData.append("cinRecto", this.state.recto);
        } else if (type === "verso" && this.state.verso) {
          formData.append("cinVerso", this.state.verso);
        } else {
          this.setState({
            errorMessage: `Veuillez sélectionner un fichier ${
              type === "recto" ? "recto" : "verso"
            } avant de continuer.`,
          });
          return;
        }

        // Send the POST request to upload the files
        const response = await fetch(`${ApiUrl}citoyens/cin-images`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });

        // Handle response
        if (response.ok) {
          const responseData = await response.json();
          this.handleDelete(type);
          this.getPatientCin();
          this.setState({
            successMessage: "Fichier téléchargé avec succès !",
            errorMessage: null,
          });
          setTimeout(() => this.setState({ successMessage: null }), 5000);

          console.log("Success:", responseData);
        } else {
          const errorData = await response.json();

          // Extract and format error messages
          const errorMessages = errorData.errors
            ? Object.values(errorData.errors).flat().join("\n")
            : "Erreur lors du téléchargement du fichier.";

          this.setState({
            errorMessage: errorMessages,
            successMessage: null, // Clear any previous success messages
          });

          console.error("Error:", errorData);
        }
      } catch (error) {
        // Handle network or unexpected errors
        this.setState({
          errorMessage: "Une erreur s'est produite. Veuillez réessayer.",
        });
        console.error("Error:", error);
      }
    }
  };

  handleShowModal = (imageUrl) => {
    this.setState({ showModal: true, modalImage: imageUrl });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false, modalImage: "" });
  };

  handleDownload = (imageUrl, imageName) => {
    // Create a temporary anchor element to trigger the download
    const a = document.createElement("a");
    a.href = imageUrl; // URL of the image
    a.download = imageName; // Set the name of the downloaded file
    a.click(); // Programmatically click the anchor element to trigger the download
  };

  handleEditClick = (imageType) => {
    this.setState({ editingImageType: imageType, showEditModal: true });
  };

  toggleEditModal = () => {
    this.setState((prevState) => ({
      showEditModal: !prevState.showEditModal,
    }));
  };

  render() {
    const { recto, verso, citoyenInfo } = this.state;
    const { showModal, modalImage } = this.state;

    const { errorMessage } = this.state;
    return (
      <div>
        {!citoyenInfo.cinRecto || !citoyenInfo.cinVerso ? (
          <p className="text-muted">Charger vos images de CIN</p>
        ) : (
          <div></div>
        )}

        {this.state.successMessage && (
          <div className="alert alert-success">{this.state.successMessage}</div>
        )}

        {!citoyenInfo.cinRecto || !citoyenInfo.cinVerso ? (
          <div
            className="alert alert-danger custom-alert-danger mb-5"
            style={{
              padding: "20px",
              borderRadius: "8px",
              backgroundColor: "#f8d7da",
              border: "1px solid #f5c2c7",
              color: "#842029",
              fontSize: "16px",
            }}
          >
            <strong>
              <Info /> Attention :
            </strong>{" "}
            Téléchargez vos pièces d’identité pour finaliser le dossier !
          </div>
        ) : (
          <div></div>
        )}

        {errorMessage && (
          <div className="alert text-danger" role="alert">
            {errorMessage}
          </div>
        )}

        <div className="d-flex mb-5">
          {/* CIN Recto Section */}
          {!citoyenInfo.cinRecto && (
            <div className="upload-input container">
              <div className="header">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 10V9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9V10C19.2091 10 21 11.7909 21 14C21 15.4806 20.1956 16.8084 19 17.5M7 10C4.79086 10 3 11.7909 3 14C3 15.4806 3.8044 16.8084 5 17.5M7 10C7.43285 10 7.84965 10.0688 8.24006 10.1959M12 12V21M12 12L15 15M12 12L9 15"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <p>CIN Recto!</p>
              </div>
              <label htmlFor="recto" className="footer">
                <svg
                  fill="#000000"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M15.331 6H8.5v20h15V14.154h-8.169z"></path>
                  <path d="M18.153 6h-.009v5.342H23.5v-.002z"></path>
                </svg>
                <p>
                  {recto
                    ? this.truncateFileName(recto.name)
                    : "No file selected"}
                </p>
                <input
                  id="recto"
                  type="file"
                  onChange={(e) => this.handleFileChange(e, "recto")}
                  hidden
                />

                {/* Show Save button for Recto */}
                {recto && (
                  <div>
                    <button
                      className="custom-btn btn-base me-1"
                      onClick={() => this.handleSave("recto")}
                    >
                      Save
                    </button>
                    <button
                      className="custom-btn btn-danger"
                      onClick={() => this.handleDelete("recto")}
                    >
                      Delete
                    </button>
                  </div>
                )}
              </label>
            </div>
          )}

          {/* CIN Verso Section */}
          {!citoyenInfo.cinVerso && (
            <div className="upload-input container">
              <div className="header">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 10V9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9V10C19.2091 10 21 11.7909 21 14C21 15.4806 20.1956 16.8084 19 17.5M7 10C4.79086 10 3 11.7909 3 14C3 15.4806 3.8044 16.8084 5 17.5M7 10C7.43285 10 7.84965 10.0688 8.24006 10.1959M12 12V21M12 12L15 15M12 12L9 15"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <p>CIN Verso!</p>
              </div>
              <label htmlFor="verso" className="footer">
                <svg
                  fill="#000000"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M15.331 6H8.5v20h15V14.154h-8.169z"></path>
                  <path d="M18.153 6h-.009v5.342H23.5v-.002z"></path>
                </svg>
                <p>
                  {verso
                    ? this.truncateFileName(verso.name)
                    : "No file selected"}
                </p>
                <input
                  id="verso"
                  type="file"
                  onChange={(e) => this.handleFileChange(e, "verso")}
                  hidden
                />

                {/* Show Save button for Verso */}
                {verso && (
                  <div>
                    <button
                      className="custom-btn btn-base me-1"
                      onClick={() => this.handleSave("verso")}
                    >
                      Save
                    </button>
                    <button
                      className="custom-btn btn-danger"
                      onClick={() => this.handleDelete("verso")}
                    >
                      Delete
                    </button>
                  </div>
                )}
              </label>
            </div>
          )}
        </div>

        {citoyenInfo.cinRecto && (
          <>
            <h5 className="title mb-4" style={{ color: "rgb(5, 44, 101)" }}>
              # Mes documents
            </h5>

            {this.state.errorMessage && (
              <div className="alert alert-danger">
                {this.state.errorMessage}
              </div>
            )}

            <div className="table-responsive border border-bottom pb-4">
              <table className="table text-nowrap table-hover">
                <thead>
                  <tr>
                    <th scope="col">Fichier</th>
                    <th scope="col">Image</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody className="files-list">
                  {/* CIN Recto Row */}
                  {citoyenInfo.cinRecto && (
                    <tr>
                      <th scope="row">
                        <div className="d-flex align-items-center">
                          <div>Pièce d'identité - Recto</div>
                        </div>
                      </th>
                      <td>
                        <img
                          src={citoyenInfo.cinRectoBlob || ""}
                          alt="CIN Recto"
                          style={{
                            width: "120px",
                            height: "auto",
                            borderRadius: "4px",
                            border: "1px solid #ddd",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                          }}
                        />
                      </td>

                      <td>
                        <div className="hstack gap-2 fs-15">
                          <div
                            onClick={() =>
                              this.handleShowModal(
                                citoyenInfo.cinRectoBlob || ""
                              )
                            }
                            className="fw-bold cursor-pointer custom-btn btn-outline-secondary me-2"
                          >
                            <FaEye style={{ fontSize: "18px" }} />
                          </div>
                          <div
                            onClick={() =>
                              this.handleDownload(
                                citoyenInfo.cinRectoBlob,
                                "CIN Image"
                              )
                            }
                            className="fw-bold cursor-pointer btn-icon custom-btn btn-outline-secondary "
                          >
                            <Download style={{ fontSize: "18px" }} />
                          </div>
                          <div
                            onClick={() => this.handleEditClick("cinRecto")}
                            className="fw-bold cursor-pointer btn-icon custom-btn btn-outline-secondary "
                          >
                            <Edit style={{ fontSize: "18px" }} />
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                  {/* CIN Verso Row */}
                  {citoyenInfo.cinVerso && (
                    <tr>
                      <th scope="row">
                        <div className="d-flex align-items-center">
                          <div>Pièce d'identité - Verso</div>
                        </div>
                      </th>
                      <td>
                        <img
                          src={citoyenInfo.cinVersoBlob || ""}
                          alt="CIN Recto"
                          style={{
                            width: "120px",
                            height: "auto",
                            borderRadius: "4px",
                            border: "1px solid #ddd",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                          }}
                        />
                      </td>
                      <td>
                        <div className="hstack gap-2 fs-15">
                          <div
                            onClick={() =>
                              this.handleShowModal(
                                citoyenInfo.cinVersoBlob || ""
                              )
                            }
                            className="custom-btn fw-bold btn-outline-secondary me-2"
                          >
                            <FaEye style={{ fontSize: "18px" }} />
                          </div>
                          <div
                            className="custom-btn fw-bold btn-outline-secondary "
                            onClick={() =>
                              this.handleDownload(
                                citoyenInfo.cinVersoBlob || "",
                                "CIN Image"
                              )
                            }
                          >
                            <Download style={{ fontSize: "18px" }} />
                          </div>
                          <div
                            onClick={() => this.handleEditClick("cinVerso")}
                            className="custom-btn fw-bold btn-outline-secondary "
                          >
                            <Edit style={{ fontSize: "18px" }} />
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}

        {showModal && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Vue de l'image</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={this.handleCloseModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <img
                    src={modalImage}
                    alt="CIN"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "8px",
                    }}
                  />
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={this.handleCloseModal}
                  >
                    Fermer
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Edit Modal */}
        <EditCinImage
          show={this.state.showEditModal}
          onHide={this.toggleEditModal}
          cinType={this.state.editingImageType}
          token={this.token}
          onSuccess={this.getPatientCin}
          onAlert={this.handleSuccess}
        />
      </div>
    );
  }
}

export default UploadFileInput;
